import { styled } from '@linaria/react';

// eslint-disable-next-line no-restricted-imports
import { MqDesktop, MqMobileOnly, MqTablet } from '~theme/media';

export const ConversationOuter = styled.div`
	--chat-horizontal-padding: var(--screen-padding);
	position: relative;
	min-height: 0;
	grid-area: center;
	will-change: max-height;
	${MqMobileOnly} {
		position: fixed;
		z-index: 1;
		top: var(--keyboard-height, 0);
		bottom: 0;
		left: 0;
		width: 100%;
		/* height: calc(var(--vh) - var(--keyboard-height, 0px)) !important; */
		/* top: 0; */
		background: var(--page-bg);
		overscroll-behavior: contain;
		will-change: height;
	}
`;

export const ConversationInner = styled.div`
	position: relative;
	z-index: 1;
	display: grid;
	width: 100%;
	max-width: 100%;
	height: 100%;
	padding-top: var(--safe-top);
	padding-bottom: var(--safe-bottom);
	margin: 0 auto;
	grid-template-areas: 'header' 'history' 'gen-loader' 'gifts' 'suggested-text' 'input';
	grid-template-rows: auto minmax(0, 1fr) auto;
	${MqTablet} {
		max-width: 680px;
		padding-top: 40px;
	}

	${MqDesktop} {
		padding-top: 0;
	}
	& > .loader {
		grid-area: history;
	}
`;

export const ConversationLoader = styled.div`
	position: absolute;
	top: 56px;
	right: 0;
	pointer-events: none;

	${MqTablet} {
		top: 0;
	}
	& > * {
		position: relative;
		left: -50%;
	}
`;
